// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__NOru8","toggleWrap":"styles_toggleWrap__VIE4w","content":"styles_content__1HeVk","selectAreaCode":"styles_selectAreaCode__32uQo"};